export const delimiter = () => ({
    animationName: "blink",
    animationIterationCount: "infinite",
    animationTimingFunction: "step-end",
    animationDuration: "2s",
});
